import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { FaEdit } from "react-icons/fa";
import { AiFillSetting } from "react-icons/ai";
import { Button } from "antd";

import FormMgtSensorData from "./FormMgtSensorData";

import Actions from "../../redux/actions";
import TableControl from "../../component/table/TableControl";

export default function TableMgtSensorData(props) {

  const [columns, setColumns] = useState([])
  const data = useSelector((state) => state.mgtSensorData.data);
  const tblLoading = useSelector((state) => state.mgtSensorData.tblDataLoading);
  const dispatch = useDispatch();

  useEffect(() => {
    const init = async () => {};

    initColumn(props.permission)
    init();
  }, [dispatch, data, props.permission]);

  const initColumn = (permission) =>{
    const column = [
      {
        title: "วัน/เวลา",
        dataIndex: "date",
        align: "center",
        className: "cn allow-search",
        sorter: (a, b) => new Date(a.date) - new Date(b.date) 
      },
      {
        title: "สถานี",
        dataIndex: "station_name",
        align: "center",
        className: "cn allow-search",
        sorter: (a, b) => a.station_name.localeCompare(b.station_name),
      },
      {
        title: "เซนเซอร์",
        dataIndex: "sensor_name",
        align: "center",
        className: "cn allow-search",
        sorter: (a, b) => a.sensor_name.localeCompare(b.sensor_name),
      },
      {
        title: "พารามิเตอร์",
        dataIndex: "parameter_name",
        align: "center",
        className: "cn allow-search",
        sorter: (a, b) => a.parameter_name.localeCompare(b.parameter_name),
      },
      {
        title: "ระดับน้ำจากสถานี",
        dataIndex: "raw_data",
        align: "center",
        className: "cn allow-search",
        sorter: (a, b) => a.raw_data - b.raw_data,
      },
      {
        title: "ระดับน้ำเทียบระดับอ้างอิง",
        dataIndex: "proc_data",
        align: "center",
        className: "cn allow-search",
        sorter: (a, b) => a.proc_data - b.proc_data,
      },
    ];

    if(permission.indexOf("update") >= 0 || permission.indexOf("delete") >= 0){
      column.push({
        title: <AiFillSetting />,
        dataIndex: "",
        align: "center",
        className: "cell-action",
        render: (_, record) => (
          <>
            {props.permission.indexOf("update") >= 0 ? (
              <Button className="btn-edit-data" onClick={() => { dispatch( Actions.popup.toggleVisible( true, "", "", <FormMgtSensorData  permission={props.permission} data={record} />));}}>
                <FaEdit />
              </Button>
            ) : (<></>)}
          </>
        ),
      },)
    }

    setColumns(column)
  }

  return (
    <TableControl
      className={
        "table-mgt-sensor-data" + (props.className ? props.className : "")
      }
      data={data}
      filterData={props.filterData}
      fncSetFilterData={props.fncSetFilterData}
      columns={columns}
      dataSet={1}
      loading={tblLoading}
    />
  );
}
